module.exports = __webpack_public_path__ + "static/fonts/iconfont.94f28b5b.ttf";